import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Home() {
  const [roomIdInput, setRoomIdInput] = useState('');
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleJoin = () => {
    if (!roomIdInput.trim()) {
      alert(t('roomIdError'));
      return;
    }
    navigate(`/join/${roomIdInput.trim()}`);
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h2 style={styles.subTitle}>{t('title')}</h2>

        <p style={styles.welcomeText}>
          {t('welcomeMessage')}
        </p>

        <div style={styles.buttonsContainer}>
          <Link 
            to="/create" 
            style={styles.createButton}
          >
            {t('createButton')}
          </Link>

          <div style={styles.joinSection}>
            <div style={styles.inputGroup}>
              <input
                type="text"
                placeholder={t('roomCodePlaceholder')}
                value={roomIdInput}
                onChange={(e) => setRoomIdInput(e.target.value)}
                style={styles.input}
                onKeyPress={(e) => e.key === 'Enter' && handleJoin()}
              />
              <button 
                onClick={handleJoin} 
                style={styles.joinButton}
              >
                {t('joinButton')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2%',
    backgroundColor: '#ffffff',
    maxWidth: '100%',
    margin: '0 auto',
    boxSizing: 'border-box',
  },
  subTitle: {
    fontSize: 'clamp(1rem, 3vw, 1.25rem)',
    fontWeight: 400,
    margin: 0,
    color: '#666',
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
    textAlign: 'center',
    marginBottom: '2rem',
    padding: '0 1rem',
  },
  welcomeText: {
    fontSize: 'clamp(0.9rem, 2.5vw, 1.1rem)',
    color: '#444',
    lineHeight: 1.6,
    margin: '0 auto 3rem',
    textAlign: 'center',
    maxWidth: '90%',
  },
  buttonsContainer: {
    width: '100%',
    maxWidth: '400px',
    margin: '0 auto',
    padding: '0 1rem',
  },
  createButton: {
    display: 'block',
    width: '100%',
    padding: 'clamp(0.8rem, 2vw, 1rem)',
    border: '2px solid #000',
    borderRadius: '8px',
    backgroundColor: 'transparent',
    color: '#000',
    textDecoration: 'none',
    textAlign: 'center',
    fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
    fontWeight: 600,
    marginBottom: '1.5rem',
    transition: 'all 0.2s ease',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: '#000',
      color: '#fff',
    },
  },
  inputGroup: {
    display: 'flex',
    flexDirection: ['column', 'row'],
    gap: '0.5rem',
    width: '100%',
    '@media (min-width: 480px)': {
      flexDirection: 'row'
    }
  },
  input: {
    flex: 1,
    padding: 'clamp(0.8rem, 2vw, 1rem)',
    border: '1px solid #ddd',
    borderRadius: '8px',
    fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
    outline: 'none',
    transition: 'border-color 0.2s',
    minWidth: '120px',
    ':focus': {
      borderColor: '#000',
    },
  },
  joinButton: {
    padding: 'clamp(0.8rem, 2vw, 1rem) clamp(1rem, 3vw, 2rem)',
    backgroundColor: '#000',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'opacity 0.2s',
    minWidth: '100px',
    ':hover': {
      opacity: 0.9,
    },
  },
};

export default Home;